<template>
    <div>
        <h4 class="text-center">{{ filtereddata.length }} Result{{ filtereddata.length > 1 ? 's' : ''}} from Search</h4>
        
          <div >    
            <div class="flex-listing" v-if="searchingfor == 'question'">
                <QuestionsForList
                    v-for="(item, index) in filtereddata" :key="item.track_id"
                    :question="item"
                    :clearance="$route.query.clearance"
                    class="questions-lister listing-items"
                    :sn="index + 1"
                    @refetch="refetchQuestions"
                    :source="source"

                />
            </div>

            <div class="flex-listing" v-if="searchingfor == 'topic'">
                <topicsForList
                  v-for="item in filtereddata" :key="item.track_id"
                  :topic="item"
                  class="listing-items"
                />
            </div>
            <div class="flex-listing" v-if="searchingfor == 'blogpost'">
                <blogpostsForList
                  v-for="item in filtereddata" :key="item.track_id"
                  :blogpost="item"
                  class="listing-items"
                />
            </div>

            <div class="flex-listing" v-if="searchingfor == 'users'">
              <usersList
                  class="mt-2"
                  v-for="(item, index) in filtereddata" :key="item.track_id"
                  :sn="index + 1"
                  :user="filtereddata"
              ></usersList>
          </div>
          </div>

    </div>
</template>

<script>
import { mapActions } from "vuex";
import QuestionsForList from "@/components/admin/QuestionsForList"
import topicsForList from "@/components/admin/topicsForList"
import blogpostsForList from "@/components/admin/blogpostsForList"

export default {
  props: ["searchingfor","filtereddata", "source"],
  components : {
      QuestionsForList,
      topicsForList,
      blogpostsForList
  },
  data() {
    return {
        deleting: false,
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 5,
        endnum: 20,
    };
  },
  methods: {
    ...mapActions("admin", ["perfDelete", "fetchQuestions"]),
    queDelete() {
      this.deleting = true;
      let action = "";
      if (this.question.is_deleted == "Yes") {
        action = "Undelete";
      } else {
        action = "Delete";
      }
      let delobj = {
        action,
        trackid: this.question.track_id,
      };
      // console.log(delobj);
      return this.perfDelete(delobj).then(() => {
        this.fetchQuestions();
        this.deleting = false;
        // console.log(response.data);
      });
    },
    refetchQuestions(){
        this.$emit("refetch")
        this.$emit("clearSearch")
    }
  },
  computed: {
    variant() {
      if (this.question.is_deleted == "Yes") {
        return "info";
      } else {
        return "danger";
      }
    },
    btntext() {
      if (this.question.is_deleted == "Yes") {
        return "Undelete";
      } else {
        return "Delete";
      }
    },
  },
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}
.questions-lister{
  width: 300px;
  height :max-content;
}


@media screen and (max-width: 999px) {
    .questions-lister {
        width:100%;
    }
}
</style>
